import { fetchAuthSession } from 'aws-amplify/auth';

interface SwaggerRequest {
  url: string;
  method: string;
  headers: Record<string, string>;
  body?: any;
}

interface SwaggerResponse {
  status: number;
  statusText: string;
  headers: Record<string, string>;
  data: any;
  text: string;
  url: string;
}

// Simple proxy for handling Swagger UI requests to avoid CORS issues
export const executeRequest = async (req: SwaggerRequest): Promise<SwaggerResponse> => {
  try {
    // Use token from local storage that might have been saved by the login endpoint
    const token = localStorage.getItem('swaggerApiToken');
    
    // Prepare headers
    const requestHeaders: Record<string, string> = {
      'Content-Type': 'application/json',
      ...req.headers
    };
    
    // Add authorization header if token exists
    if (token) {
      requestHeaders['Authorization'] = `Bearer ${token}`;
    }
    
    // Process body
    let bodyToSend: string | undefined = undefined;
    if (req.body) {
      bodyToSend = typeof req.body === 'object' ? JSON.stringify(req.body) : req.body;
    }
    
    // Execute the request
    const response = await fetch(req.url, {
      method: req.method,
      headers: requestHeaders,
      body: bodyToSend,
      credentials: 'include',
    });
    
    // Parse response
    let responseData;
    let responseText = '';
    try {
      responseText = await response.clone().text();
      
      // Try to parse as JSON if appropriate
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        try {
          responseData = JSON.parse(responseText);
        } catch (e) {
          responseData = responseText;
        }
      } else {
        responseData = responseText;
      }
    } catch (e) {
      responseText = 'Error reading response';
      responseData = responseText;
    }
    
    // Return response in format expected by Swagger UI
    return {
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries()),
      data: responseData,
      text: responseText,
      url: req.url
    };
  } catch (error) {
    console.error('API request failed:', error);
    return {
      status: 500,
      statusText: 'Error',
      headers: {},
      data: { error: 'Failed to execute request' },
      text: JSON.stringify({ error: 'Failed to execute request' }),
      url: req.url
    };
  }
};